import { useEffect, useState } from 'react';

export interface UseIsSelectedProps {
  allChainPaths: string[];
  currentProjectSubchains: string[];
  isLoadingAddChainsToProjects?: boolean;
}

interface CheckIsSelectedParams
  extends Omit<UseIsSelectedProps, 'isLoadingAddChainsToProjects'> {}

const checkIsSelected = ({
  allChainPaths,
  currentProjectSubchains,
}: CheckIsSelectedParams) =>
  allChainPaths.every(path => currentProjectSubchains.includes(path));

export const useIsSelected = ({
  allChainPaths,
  currentProjectSubchains,
  isLoadingAddChainsToProjects,
}: UseIsSelectedProps) => {
  const [isSelected, setIsSelected] = useState(
    checkIsSelected({ allChainPaths, currentProjectSubchains }),
  );

  useEffect(() => {
    if (!isLoadingAddChainsToProjects) {
      setIsSelected(
        checkIsSelected({ allChainPaths, currentProjectSubchains }),
      );
    }
  }, [allChainPaths, currentProjectSubchains, isLoadingAddChainsToProjects]);

  return isSelected;
};
